import React from 'react';
import { Text, View, useWindowDimensions } from 'react-native';
import theme from 'theme';
import { AgeRatingKey } from 'utils/ageRating';
import { ProgramType } from 'utils/enum';
import { calcSizeForDevice, getResponsiveSize, hourFormatterBySeconds } from 'utils/index';
import { Platform } from 'utils/platform';

import { useProgram } from './context';

import Rating from 'components/Rating';

const ProgramHeader: React.FC = () => {
  const program = useProgram();

  const notShowOnLive = program?.type !== ProgramType.LIVE;
  const numSeasons = program.seasons?.length;
  const { width } = useWindowDimensions();
  const isSmallScreen = width < 767;

  return (
    <View style={{ marginTop: ProgramType.PROGRAM === program?.type ? 10 : 0, marginBottom: 10 }}>
      {Platform.OS !== 'web' && !Platform.isTV ? (
        <View style={{ paddingTop: 16 }}>
          {program?.title && (
            <Text style={{ color: theme.colors.base.white, fontWeight: 'bold', fontSize: 24 }}>
              {program?.title}
            </Text>
          )}

          <View style={{ flexDirection: 'row', alignItems: 'center', marginVertical: 16 }}>
            <View style={{ flexDirection: 'row' }}>
              {program?.genre?.[0].name && notShowOnLive && !program.hideSeasonsLabel && (
                <Text
                  style={{ marginRight: 12, fontWeight: 'bold', color: theme.colors.base.white }}>
                  {numSeasons
                    ? `${numSeasons} TEMPORADA${numSeasons > 1 ? 'S' : ''}`
                    : program?.genre?.[0].name}
                </Text>
              )}
              {notShowOnLive && program?.year && (
                <Text
                  style={{
                    marginRight: 20,
                    marginLeft: 16,
                    fontWeight: 'bold',
                    color: theme.colors.base.white,
                  }}>
                  {program?.year}
                </Text>
              )}
              {notShowOnLive && program?.duration && (
                <Text
                  style={{ marginRight: 32, fontWeight: 'bold', color: theme.colors.base.white }}>
                  {hourFormatterBySeconds(program?.duration)}
                </Text>
              )}
            </View>

            {program?.rating && <Rating ageRatingKey={program?.rating as AgeRatingKey} />}
          </View>
          {program.rateDescription?.length > 0 && (
            <Text
              style={{ color: 'white', marginBottom: 20, fontFamily: theme.fonts.inter.regular }}>
              {program.rateDescription}
            </Text>
          )}
        </View>
      ) : (
        <View style={{ flexDirection: 'column' }}>
          <View style={{ marginBottom: calcSizeForDevice(8) }}>
            {program?.title && (
              <Text
                style={{
                  fontSize: getResponsiveSize({
                    base: calcSizeForDevice(32),
                    xs: calcSizeForDevice(48, 64),
                    lg: calcSizeForDevice(64),
                  }),
                  lineHeight: getResponsiveSize({
                    xs: 48,
                    lg: calcSizeForDevice(70),
                  }),
                  marginBottom: calcSizeForDevice(10, 0),
                  color: 'white',
                  fontFamily: 'system-ui',
                  fontWeight: 'bold',
                  letterSpacing: -0.2,
                }}>
                {program?.title}
              </Text>
            )}
            {program?.genre?.[0].name && notShowOnLive && !program.hideSeasonsLabel && (
              <Text
                style={{
                  fontFamily: 'system-ui',
                  fontWeight: 'bold',
                  lineHeight: 22,
                  color: 'white',
                  fontSize: calcSizeForDevice(16),
                }}>
                {numSeasons
                  ? `${numSeasons} TEMPORADA${numSeasons > 1 ? 'S' : ''}`
                  : program?.genre?.[0].name}
              </Text>
            )}
          </View>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: calcSizeForDevice(20),
            }}>
            {program?.rating && (
              <View style={{ marginRight: calcSizeForDevice(16) }}>
                <Rating ageRatingKey={program?.rating as AgeRatingKey} />
              </View>
            )}

            {program.rateDescription?.length > 0 && (
              <Text
                style={{
                  fontFamily: 'system-ui',
                  fontSize: calcSizeForDevice(18, 24),
                  lineHeight: calcSizeForDevice(24, 28),
                  marginRight: calcSizeForDevice(15),
                  color: 'white',
                }}>
                {program.rateDescription}
              </Text>
            )}
            {notShowOnLive && program?.year && (
              <Text
                style={{
                  fontFamily: 'system-ui',
                  fontWeight: 'bold',
                  lineHeight: 22,
                  color: 'white',
                  fontSize: calcSizeForDevice(16, 24),
                }}>
                {program?.year}
              </Text>
            )}
          </View>

          {!isSmallScreen && program?.summary && (
            <Text
              style={{
                fontFamily: 'system-ui',
                fontSize: calcSizeForDevice(18, 24),
                lineHeight: calcSizeForDevice(24, 30),
                marginBottom: calcSizeForDevice(10, 30),
                maxWidth: Platform.isTV ? '100%' : '80%',
                textAlign: 'justify',
                color: 'white',
              }}>
              {program?.summary}
            </Text>
          )}
        </View>
      )}
    </View>
  );
};

export default ProgramHeader;
